import { useState } from "react";

interface Props {
  onSubmit: (orderNumber: string, email: string) => void;
  loading: boolean;
}

export default function OrderLookupForm({ onSubmit, loading }: Props) {
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!orderNumber.trim() || !email.trim()) return;
    onSubmit(orderNumber.trim(), email.trim());
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Order number */}
        <div>
          <label htmlFor="order-number" className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
            Order Number
          </label>
          <div className="relative">
            <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-sm font-bold select-none pointer-events-none">
              #
            </span>
            <input
              id="order-number"
              type="text"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              placeholder="1001"
              required
              className="w-full border border-gray-200 rounded-lg pl-8 pr-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent transition bg-white"
            />
          </div>
          <p className="text-[11px] text-gray-400 mt-1">Found in your confirmation email</p>
        </div>

        {/* Email */}
        <div>
          <label htmlFor="order-email" className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
            Email Address
          </label>
          <input
            id="order-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
            className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent transition bg-white"
          />
          <p className="text-[11px] text-gray-400 mt-1">Email used at checkout</p>
        </div>
      </div>

      <button
        type="submit"
        disabled={loading || !orderNumber.trim() || !email.trim()}
        className="w-full sm:w-auto flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 disabled:bg-gray-200 disabled:text-gray-400 text-white font-bold px-8 py-3 rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 flex items-center justify-center animate-spin">
              <i className="ri-loader-4-line"></i>
            </div>
            Looking up order...
          </>
        ) : (
          <>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line"></i>
            </div>
            Track My Order
          </>
        )}
      </button>
    </form>
  );
}
